// eslint-disable-next-line import/prefer-default-export
export const getDetailTableId = (
  templateId?: string | number | null
): string | undefined => {
  if (!templateId) return undefined;

  return `detail-table-${templateId}`;
};
